// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3gqjC","paymentContainer":"PaymentPage_paymentContainer__1dUWM"};